/* eslint-disable import/no-anonymous-default-export */
import LocationOnIcon from "@mui/icons-material/LocationOn";
import FlagOutlinedIcon from "@mui/icons-material/FlagOutlined";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import PowerSettingsNewOutlinedIcon from "@mui/icons-material/PowerSettingsNewOutlined";
import AddIcon from "@mui/icons-material/Add";
import ListAltIcon from "@mui/icons-material/ListAlt";
import GroupOutlinedIcon from "@mui/icons-material/GroupOutlined";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import PermIdentityOutlinedIcon from "@mui/icons-material/PermIdentityOutlined";
import NoteAltOutlinedIcon from "@mui/icons-material/NoteAltOutlined";
import ManageAccountsOutlinedIcon from "@mui/icons-material/ManageAccountsOutlined";
import MonitorHeartIcon from "@mui/icons-material/MonitorHeart";
import AirplanemodeActiveIcon from "@mui/icons-material/AirplanemodeActive";
export default [
  {
    name: "خانه",
    path: "/",
    icon: HomeOutlinedIcon,
  },
  { type: "line" },
  {
    name: "مسافران",
    path: "/passenger/list",
    icon: GroupOutlinedIcon,
  },
  {
    name: "ناوگان",
    path: "/driver/list",
    icon: PermIdentityOutlinedIcon,
  },
  {
    name: "مانیتورینگ",
    path: "/monitoring",
    icon: MonitorHeartIcon,
  },
  { type: "line" },
  {
    name: "دربستی",
    path: "/hiring-list",
    icon: ListAltIcon,
  },

  {
    name: "سرویس",
    path: "/services",
    icon: ListAltIcon,
  },
  {
    name: "انواع هواپیما (ویژه ایرلاین)",
    path: "/airplane",
    icon: AirplanemodeActiveIcon,
  },
  { type: "line" },
  {
    name: "آدرس",
    path: "/address",
    icon: LocationOnIcon,
  },
  {
    name: "اپراتورها",
    path: "/operator",
    icon: ManageAccountsOutlinedIcon,
  },
  {
    name: "پروفایل",
    path: "/profile",
    icon: SettingsOutlinedIcon,
  },
  { type: "line" },
  {
    name: "خروج",
    path: "/logout",
    icon: PowerSettingsNewOutlinedIcon,
  },
];
